import React, { useContext } from 'react';
import CanvasCard from '../../Visualisations/CanvasCard';
import { ChartTopBar } from '../../Chart';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import StackedBarContent from './StackedBarContent';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';

const StackedBar = ({
  chartDefinition,
  chartRef,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={<ChartTopBar chartDefinition={chartDefinition} />}
      content={
        <StackedBarContent
          chartDefinition={chartDefinition}
          chartRef={chartRef}
        />
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default StackedBar;
